import {create} from "zustand";


interface UseModalStore {
    isEditContactDialogOpen: boolean;
    isConfirmationDialogOpen: boolean;
    toggleIsEditContactDialogOpen: () => void;
    toggleIsConfirmationDialogOpen: () => void;
}

const useModalState = create<UseModalStore>(set =>({
    isEditContactDialogOpen: false,
    isConfirmationDialogOpen: false,
    toggleIsEditContactDialogOpen: ()=> set(state => ({
        isEditContactDialogOpen: !state.isEditContactDialogOpen
    })),
    toggleIsConfirmationDialogOpen: ()=> set(state => ({
        isConfirmationDialogOpen: !state.isConfirmationDialogOpen
    })),
}))


export default useModalState;
